module.exports = __webpack_public_path__ + "img/toalha-mobile.0b7a631a.png";